// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skeleton[data-v-fbc201bc] {
  width: inherit;
  height: inherit;
}
.skeleton .skeleton-panel > .avatar[data-v-fbc201bc] {
  margin: 0;
}
.skeleton .avatar[data-v-fbc201bc] {
  /*float: left;*/
  width: 33px;
  height: 33px;
  background-color: #ccc;
  border-radius: 10%;
  margin: 8px;
  background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
  background-size: 600px;
  animation: shine-avatar-fbc201bc 1.6s infinite linear;
}
.skeleton .title[data-v-fbc201bc] {
  /*float: left;*/
  width: 70%;
  height: 30px;
  background-color: #ddd;
  margin: 8px;
  border-radius: 7px;
  background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
  background-size: 600px;
  animation: shine-lines-fbc201bc 2.6s infinite linear;
}
.skeleton .panel[data-v-fbc201bc] {
  /*float: left;*/
  width: 90%;
  min-height: 350px;
  background-color: #ddd;
  margin: 8px;
  border-radius: 3px;
  background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
  background-size: 600px;
  animation: shine-lines-fbc201bc 2.6s infinite linear;
}
.skeleton .panel.panel--truncated[data-v-fbc201bc] {
  min-height: 125px;
  margin: 0px;
  width: 100%;
}
.skeleton .line[data-v-fbc201bc] {
  float: left;
  width: 80%;
  height: 16px;
  margin-top: 12px;
  background-color: #ddd;
  border-radius: 7px;
  background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
  background-size: 600px;
  animation: shine-lines-fbc201bc 2.6s infinite linear;
}
.skeleton .line.long[data-v-fbc201bc] {
  width: 100%;
}
.skeleton .avatar + .line[data-v-fbc201bc] {
  margin-top: 11px;
  width: 100px;
  background-color: #ddd;
}
.skeleton .line ~ .line[data-v-fbc201bc] {
  background-color: #ddd;
}
.skeleton .label[data-v-fbc201bc] {
  float: left;
  width: 30%;
  height: 8px;
  margin-top: 12px;
  background-color: #ddd;
  border-radius: 7px;
  background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
  background-size: 600px;
  animation: shine-lines-fbc201bc 2.6s infinite linear;
}
.skeleton .input[data-v-fbc201bc] {
  float: left;
  width: 80%;
  height: 16px;
  margin-top: 12px;
  background-color: #ddd;
  border-radius: 7px;
  background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
  background-size: 600px;
  animation: shine-lines-fbc201bc 2.6s infinite linear;
}
@keyframes shine-lines-fbc201bc {
0% {
    background-position: -100px;
}
40%,
  100% {
    background-position: 1400px;
}
}
@-ms-keyframes shine-lines-fbc201bc {
0% {
    background-position: -100px;
}
40%,
  100% {
    background-position: 1400px;
}
}
@-webkit-keyframes shine-lines-fbc201bc {
0% {
    background-position: -100px;
}
40%,
  100% {
    background-position: 1400px;
}
}
@keyframes shine-avatar-fbc201bc {
0% {
    background-position: -32px;
}
40%,
  100% {
    background-position: 208px;
}
}
@-webkit-keyframes shine-avatar-fbc201bc {
0% {
    background-position: -32px;
}
40%,
  100% {
    background-position: 208px;
}
}
@-ms-keyframes shine-avatar-fbc201bc {
0% {
    background-position: -32px;
}
40%,
  100% {
    background-position: 208px;
}
}
/* Animations to fade the skeleton in and out */
@-webkit-keyframes fadein-fbc201bc {
from {
    bottom: 0;
    opacity: 0;
}
to {
    bottom: 30px;
    opacity: 1;
}
}
@keyframes fadein-fbc201bc {
from {
    bottom: 0;
    opacity: 0;
}
to {
    bottom: 30px;
    opacity: 1;
}
}
@-webkit-keyframes fadeout-fbc201bc {
from {
    bottom: 30px;
    opacity: 1;
}
to {
    bottom: 0;
    opacity: 0;
}
}
@keyframes fadeout-fbc201bc {
from {
    bottom: 30px;
    opacity: 1;
}
to {
    bottom: 0;
    opacity: 0;
}
}
`, "",{"version":3,"sources":["webpack://./src/js/netpify/components/np-skeleton.vue","webpack://./np-skeleton.vue"],"names":[],"mappings":"AACI;EACI,cAAA;EACA,eAAA;ACAR;ADGI;EACI,SAAA;ACDR;ADII;ECFF,eAAe;EDKT,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,2EAAA;EACA,sBAAA;EACA,qDAAA;ACHR;ADMI;ECJF,eAAe;EDMT,UAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,2EAAA;EACA,sBAAA;EACA,oDAAA;ACJR;ADOI;ECLF,eAAe;EDOT,UAAA;EACA,iBAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,2EAAA;EACA,sBAAA;EACA,oDAAA;ACLR;ADQI;EACI,iBAAA;EACA,WAAA;EACA,WAAA;ACNR;ADSI;EACI,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,2EAAA;EACA,sBAAA;EACA,oDAAA;ACPR;ADSI;EACI,WAAA;ACPR;ADUI;EACI,gBAAA;EACA,YAAA;EACA,sBAAA;ACRR;ADWI;EACI,sBAAA;ACTR;ADYI;EACI,WAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,2EAAA;EACA,sBAAA;EACA,oDAAA;ACVR;ADYI;EACI,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,2EAAA;EACA,sBAAA;EACA,oDAAA;ACVR;ADcI;AACI;IACI,2BAAA;ACZV;ADcM;;IACI,2BAAA;ACXV;AACF;ADcI;AACI;IACI,2BAAA;ACZV;ADcM;;IACI,2BAAA;ACXV;AACF;ADcI;AACI;IACI,2BAAA;ACZV;ADcM;;IACI,2BAAA;ACXV;AACF;ADcI;AACI;IACI,0BAAA;ACZV;ADcM;;IACI,0BAAA;ACXV;AACF;ADcI;AACI;IACI,0BAAA;ACZV;ADcM;;IACI,0BAAA;ACXV;AACF;ADcI;AACI;IACI,0BAAA;ACZV;ADcM;;IACI,0BAAA;ACXV;AACF;AACA,+CAA+C;ADc3C;AACI;IACI,SAAA;IACA,UAAA;ACZV;ADcM;IACI,YAAA;IACA,UAAA;ACZV;AACF;ADeI;AACI;IACI,SAAA;IACA,UAAA;ACbV;ADeM;IACI,YAAA;IACA,UAAA;ACbV;AACF;ADgBI;AACI;IACI,YAAA;IACA,UAAA;ACdV;ADgBM;IACI,SAAA;IACA,UAAA;ACdV;AACF;ADiBI;AACI;IACI,YAAA;IACA,UAAA;ACfV;ADiBM;IACI,SAAA;IACA,UAAA;ACfV;AACF","sourcesContent":["\n    .skeleton {\n        width: inherit;\n        height: inherit;\n    }\n\n    .skeleton .skeleton-panel > .avatar {\n        margin: 0;\n    }\n\n    .skeleton .avatar {\n\n        /*float: left;*/\n        width: 33px;\n        height: 33px;\n        background-color: #ccc;\n        border-radius: 10%;\n        margin: 8px;\n        background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);\n        background-size: 600px;\n        animation: shine-avatar 1.6s infinite linear;\n    }\n\n    .skeleton .title {\n        /*float: left;*/\n        width: 70%;\n        height: 30px;\n        background-color: #ddd;\n        margin: 8px;\n        border-radius: 7px;\n        background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);\n        background-size: 600px;\n        animation: shine-lines 2.6s infinite linear;\n    }\n\n    .skeleton .panel {\n        /*float: left;*/\n        width: 90%;\n        min-height: 350px;\n        background-color: #ddd;\n        margin: 8px;\n        border-radius: 3px;\n        background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);\n        background-size: 600px;\n        animation: shine-lines 2.6s infinite linear;\n    }\n\n    .skeleton .panel.panel--truncated {\n        min-height: 125px;\n        margin: 0px;\n        width: 100%;\n    }\n\n    .skeleton .line {\n        float: left;\n        width: 80%;\n        height: 16px;\n        margin-top: 12px;\n        background-color: #ddd;\n        border-radius: 7px;\n        background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);\n        background-size: 600px;\n        animation: shine-lines 2.6s infinite linear;\n    }\n    .skeleton .line.long {\n        width: 100%;\n    }\n\n    .skeleton .avatar + .line {\n        margin-top: 11px;\n        width: 100px;\n        background-color: #ddd;\n    }\n\n    .skeleton .line ~ .line {\n        background-color: #ddd;\n    }\n\n    .skeleton .label {\n        float: left;\n        width: 30%;\n        height: 8px;\n        margin-top: 12px;\n        background-color: #ddd;\n        border-radius: 7px;\n        background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);\n        background-size: 600px;\n        animation: shine-lines 2.6s infinite linear;\n    }\n    .skeleton .input {\n        float: left;\n        width: 80%;\n        height: 16px;\n        margin-top: 12px;\n        background-color: #ddd;\n        border-radius: 7px;\n        background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);\n        background-size: 600px;\n        animation: shine-lines 2.6s infinite linear;\n    }\n\n\n    @keyframes shine-lines {\n        0% {\n            background-position: -100px;\n        }\n        40%, 100% {\n            background-position: 1400px;\n        }\n    }\n\n    @-ms-keyframes shine-lines {\n        0% {\n            background-position: -100px;\n        }\n        40%, 100% {\n            background-position: 1400px;\n        }\n    }\n\n    @-webkit-keyframes shine-lines {\n        0% {\n            background-position: -100px;\n        }\n        40%, 100% {\n            background-position: 1400px;\n        }\n    }\n\n    @keyframes shine-avatar {\n        0% {\n            background-position: -32px;\n        }\n        40%, 100% {\n            background-position: 208px;\n        }\n    }\n\n    @-webkit-keyframes shine-avatar {\n        0% {\n            background-position: -32px;\n        }\n        40%, 100% {\n            background-position: 208px;\n        }\n    }\n\n    @-ms-keyframes shine-avatar {\n        0% {\n            background-position: -32px;\n        }\n        40%, 100% {\n            background-position: 208px;\n        }\n    }\n\n    /* Animations to fade the skeleton in and out */\n    @-webkit-keyframes fadein {\n        from {\n            bottom: 0;\n            opacity: 0;\n        }\n        to {\n            bottom: 30px;\n            opacity: 1;\n        }\n    }\n\n    @keyframes fadein {\n        from {\n            bottom: 0;\n            opacity: 0;\n        }\n        to {\n            bottom: 30px;\n            opacity: 1;\n        }\n    }\n\n    @-webkit-keyframes fadeout {\n        from {\n            bottom: 30px;\n            opacity: 1;\n        }\n        to {\n            bottom: 0;\n            opacity: 0;\n        }\n    }\n\n    @keyframes fadeout {\n        from {\n            bottom: 30px;\n            opacity: 1;\n        }\n        to {\n            bottom: 0;\n            opacity: 0;\n        }\n    }\n\n",".skeleton {\n  width: inherit;\n  height: inherit;\n}\n.skeleton .skeleton-panel > .avatar {\n  margin: 0;\n}\n.skeleton .avatar {\n  /*float: left;*/\n  width: 33px;\n  height: 33px;\n  background-color: #ccc;\n  border-radius: 10%;\n  margin: 8px;\n  background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);\n  background-size: 600px;\n  animation: shine-avatar 1.6s infinite linear;\n}\n.skeleton .title {\n  /*float: left;*/\n  width: 70%;\n  height: 30px;\n  background-color: #ddd;\n  margin: 8px;\n  border-radius: 7px;\n  background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);\n  background-size: 600px;\n  animation: shine-lines 2.6s infinite linear;\n}\n.skeleton .panel {\n  /*float: left;*/\n  width: 90%;\n  min-height: 350px;\n  background-color: #ddd;\n  margin: 8px;\n  border-radius: 3px;\n  background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);\n  background-size: 600px;\n  animation: shine-lines 2.6s infinite linear;\n}\n.skeleton .panel.panel--truncated {\n  min-height: 125px;\n  margin: 0px;\n  width: 100%;\n}\n.skeleton .line {\n  float: left;\n  width: 80%;\n  height: 16px;\n  margin-top: 12px;\n  background-color: #ddd;\n  border-radius: 7px;\n  background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);\n  background-size: 600px;\n  animation: shine-lines 2.6s infinite linear;\n}\n.skeleton .line.long {\n  width: 100%;\n}\n.skeleton .avatar + .line {\n  margin-top: 11px;\n  width: 100px;\n  background-color: #ddd;\n}\n.skeleton .line ~ .line {\n  background-color: #ddd;\n}\n.skeleton .label {\n  float: left;\n  width: 30%;\n  height: 8px;\n  margin-top: 12px;\n  background-color: #ddd;\n  border-radius: 7px;\n  background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);\n  background-size: 600px;\n  animation: shine-lines 2.6s infinite linear;\n}\n.skeleton .input {\n  float: left;\n  width: 80%;\n  height: 16px;\n  margin-top: 12px;\n  background-color: #ddd;\n  border-radius: 7px;\n  background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);\n  background-size: 600px;\n  animation: shine-lines 2.6s infinite linear;\n}\n@keyframes shine-lines {\n  0% {\n    background-position: -100px;\n  }\n  40%,\n  100% {\n    background-position: 1400px;\n  }\n}\n@-ms-keyframes shine-lines {\n  0% {\n    background-position: -100px;\n  }\n  40%,\n  100% {\n    background-position: 1400px;\n  }\n}\n@-webkit-keyframes shine-lines {\n  0% {\n    background-position: -100px;\n  }\n  40%,\n  100% {\n    background-position: 1400px;\n  }\n}\n@keyframes shine-avatar {\n  0% {\n    background-position: -32px;\n  }\n  40%,\n  100% {\n    background-position: 208px;\n  }\n}\n@-webkit-keyframes shine-avatar {\n  0% {\n    background-position: -32px;\n  }\n  40%,\n  100% {\n    background-position: 208px;\n  }\n}\n@-ms-keyframes shine-avatar {\n  0% {\n    background-position: -32px;\n  }\n  40%,\n  100% {\n    background-position: 208px;\n  }\n}\n/* Animations to fade the skeleton in and out */\n@-webkit-keyframes fadein {\n  from {\n    bottom: 0;\n    opacity: 0;\n  }\n  to {\n    bottom: 30px;\n    opacity: 1;\n  }\n}\n@keyframes fadein {\n  from {\n    bottom: 0;\n    opacity: 0;\n  }\n  to {\n    bottom: 30px;\n    opacity: 1;\n  }\n}\n@-webkit-keyframes fadeout {\n  from {\n    bottom: 30px;\n    opacity: 1;\n  }\n  to {\n    bottom: 0;\n    opacity: 0;\n  }\n}\n@keyframes fadeout {\n  from {\n    bottom: 30px;\n    opacity: 1;\n  }\n  to {\n    bottom: 0;\n    opacity: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
